module.exports = __webpack_public_path__ + "static/media/Thumbs-Up-Filled.6a4d6e0d.svg";